import { render } from "./EvolucionSalarial.vue?vue&type=template&id=6aa6852e&scoped=true"
import script from "./EvolucionSalarial.vue?vue&type=script&lang=js"
export * from "./EvolucionSalarial.vue?vue&type=script&lang=js"

import "./EvolucionSalarial.vue?vue&type=style&index=0&id=6aa6852e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6aa6852e"

export default script